import React, { Component } from "react";
import { connect } from "react-redux";
import LayoutWrap from "../Component/LayoutWrap";
import { dashboardActions } from "../../../_actions";
import { MdArrowForwardIos } from "react-icons/md";
import moment from "moment";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.dispatch(dashboardActions.getConnectDetails({}));
    this.props.dispatch(dashboardActions.getMeetingLinkDetails({}));

  }

  goToPage = (path) => {
    if (this.props.history) {
      this.props.history.push(path);
    }
  };

  render() {
    let { dashboard, insightData } = this.props;
    let { getMeetingLinkDetailsData: details } = dashboard;
    // let { insightData:userDetails } = this.props;

    function getShowExpiry(obj, fieldName) {
      const expiryDate = obj?.[`${fieldName}Expiry`] || "";
      const isExpired = obj?.[`${fieldName}Expired`] ?? false;

      console.log(fieldName, "===>|expiryDate|isExpired---->", expiryDate, isExpired)

      // Manual override
      if (isExpired) {
        return true;
      }

      // No expiry date
      if (!expiryDate) {
        return false;
      }

      // Returns true if today's date is after the expiry date
      return moment().isAfter(moment(expiryDate, "YYYY-MM-DD"), "day");
    }

    const activities = [
      {
        id: 1,
        show: !getShowExpiry(details, "introMeetingLink"),
        title: "Introduction & Orientation to Platform",
        description: "Start your day with guidance and support.",
        imgSrc: "insight/Manager-Assistance.svg",
        path: "/insight/meeting/introduction",
        actionText: "Join Meeting"
      },
      {
        id: 2,
        show: !getShowExpiry(details, "caseStudyId"),
        title: "Case Study Reading & Preparation",
        description: "Read & understand the case study to prepare for your interaction with Assessors.",
        imgSrc: "insight/Case-Study.svg",
        path: "/insight/casestudy",
        actionText: "Start",
        badge: ""
      },
      {
        id: 5,
        show: !getShowExpiry(details, "rolePlayId"),
        title: "Stakeholder Roleplay Preparation",
        description: "Read & understand the roleplay context to prepare for your interaction with Assessors.",
        imgSrc: "insight/Subordinate-Role.svg",
        path: "/insight/roleplay",
        actionText: "Start"
      },

      {
        id: 6,
        show: !getShowExpiry(details, "rolePlayMeetingLink"),
        title: "MS Teams Meeting Links (BEI, Case Study & Roleplay)",
        description: "Join this link for your 1:1 assessor interaction for the following exercises: Behavioral Event Interview, Stakeholder Roleplay & Case Study Presentation.",
        imgSrc: "insight/Play-Meeting.svg",
        path: "/insight/meeting/roleplay",
        actionText: "Join Meeting"
      },
      {
        id: 3,
        show: !getShowExpiry(details, "inboxActivity"),
        title: "Inbox Activity",
        description: "Manage and prioritize stakeholder communication.",
        imgSrc: "insight/Inbox-Activity.svg",
        path: "/insight/mailbox",
        actionText: "Check Inbox"
      },
      {
        id: 7,
        show: !getShowExpiry(details, "surveyId"),
        title: "ROM Round 1 Assessment",
        description: "135 Minutes",
        imgSrc: "insight/Situational-Judgement.svg",
        path: "/insight/survey",
        actionText: "Start Assessment"
      },
      // {
      //   id: 8,
      //   title: "Case Study PPT Upload",
      //   description: "Submit your completed case study presentation.",
      //   imgSrc: "insight/Case-Study-PPT.svg",
      //   path: "/insight/upload",
      //   actionText: "Upload PPT"
      // }
    ];

    let { getConnectDetailsData: x } = dashboard;
    let logo = x?.logo || "";

    let userName = x?.userName || "Krishna";
    let pendingCount = activities.length;


    console.log('activities', activities);


    return (
      <LayoutWrap logo={logo}>
        <div className="min-h-screen bg-white p-6 md:p-6 lg:p-10">
          <div className="w-full mx-auto">
            <header className="mb-6">
              <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight textblack">Activities</h1>
              <p className="mt-1 text-sm sm:text-base text-gray-600 font-medium">Complete your activities according to the schedule shared.</p>
            </header>

            {/* Cards Grid */}
            {true &&
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {activities.filter(prev => prev.show === true).map((task) => {
                  return (
                    <div key={task.id} className="bg-white border border-[#E2E8F0] rounded-2xl p-6 flex items-start gap-5 shadow-sm hover:shadow-md transition-shadow duration-200 relative group">
                      <div className="flex-shrink-0 w-16 h-16 rounded-full bg-[#EEF2FF] flex items-center justify-center">
                        <img src={task.imgSrc} alt={task.title} className="w-12 h-12 object-contain" onError={(e) => { e.target.style.display = 'none'; }} />
                      </div>

                      <div className="flex-1 min-w-0 pr-6">
                        <h3 className="text-lg font-semibold textblack leading-snug tracking-tight">{task.title}</h3>
                        <p className="mt-1 text-xs sm:text-sm text-[#64748B] leading-relaxed line-clamp-2">{task.description}</p>
                        <div className="mt-4">
                          <button onClick={() => this.goToPage(task.path)} className="inline-flex items-center text-base font-medium text-indigo-600 hover:text-indigo-700 transition-colors duration-150 gap-1 bg-transparent border-none p-0 cursor-pointer">
                            <span>{task.actionText}</span>
                            <span className="transform group-hover:translate-x-0.5 transition-transform duration-150">
                              <MdArrowForwardIos size={15} />
                            </span>
                          </button>
                        </div>
                      </div>

                      {task.badge && (
                        <span className="absolute bottom-6 right-6 text-sm font-medium text-[#64748B]">{task.badge}</span>
                      )}
                    </div>
                  );
                })}
              </div>
            }


          </div>

          {/* Bottom Fixed Sticky Action Bar (Responsive Mobile viewports only) */}
          {/* <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#E2E8F0] shadow-[0_-4px_12px_rgba(0,0,0,0.03)] px-4 py-3 flex items-center justify-between md:hidden z-50">
            <div className="flex flex-col">
              <span className="text-xs text-[#64748B] font-medium">Cycle Status</span>
              <span className="text-sm font-bold text-[#7C3AED]">{pendingCount} Tasks Remaining</span>
            </div>
            <button className="bg-[#7C3AED] hover:bg-[#6D28D9] text-white px-5 py-2.5 rounded-xl text-sm font-bold shadow-sm transition-colors duration-150">
              View Overview
            </button>
          </div> */}

        </div>
      </LayoutWrap >
    );
  }
}

const mapStateToProps = (state) => ({
  loggingIn: state.authentication?.loggingIn,
  panel: state.panel,
  dashboard: state.dashboard
});

export default connect(mapStateToProps)(Dashboard);